import PropTypes from 'prop-types';
import { capitalizeText } from '../../Pod/podUtils';
import { AvailabilityLocationStyles } from './AvailabilityLocation.style';

export const AvailabilityLocation = ({ comunaName }) => {
  return (
    <>
      <div className="delivery-option-location">
        <p className="delivery-location-text">
          Entrega en <span className="delivery-location-text__span">{capitalizeText(comunaName)}</span>
        </p>
      </div>
      <style jsx>{AvailabilityLocationStyles}</style>
    </>
  );
};

AvailabilityLocation.propTypes = {
  comunaName: PropTypes.string.isRequired,
};
